  // GlidePathAllocation.js
import React , { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
//import DOMPurify from 'dompurify';
//import './GlidePathAllocation.css';

import GlidepathHeader from './GlidePathAllocation/GlidepathHeader';
import GlidepathStackedChartWithSlider from './GlidePathAllocation/GlidepathStackedChartWithSlider';
import GlidepathPieChart from './GlidePathAllocation/GlidepathPieChart';
import FundAllocationTable from './GlidePathAllocation/FundAllocationTable';
import GlidepathDisclaimer from './GlidePathAllocation/GlidepathDisclaimer';
import { toChartData, toTableData } from './GlidePathAllocation/ChartDataTransformer';

const GlidePathAllocation = ({
    chartProductName = '',
    riskyAssetsLabel = '',
    defensiveAssetsLabel = '',
    GlidepathHeaderLabels = {}, 
    GlidepathStackedChartWithSliderLabels,
    GlidepathDisclaimerLabels,
    chartDataMaxYear,
    fundDataUrl,
    isTableExpandedByDefault,
    language,
  }) => {
    const [fundData, setFundData] = useState(null); 
    const [chartData, setChartData] = useState(null); 
    const { t } = useTranslation();

    useEffect(() => {
      const fetchData = async () => {
        let baseUrl = process.env.REACT_APP_DATA_URL  || '#{DATA_URL}';

        const fundResponse = await fetch(`${baseUrl}${fundDataUrl}`);
    
        if (!fundResponse.ok) {
          throw new Error('HTTP error!');
        }
    
        const fetchedFundDataArray = await fundResponse.json();
        const fundDataObject = Array.isArray(fetchedFundDataArray) ? fetchedFundDataArray[0] : fetchedFundDataArray;
        var transformedTableData = toTableData(fundDataObject, language);

        setFundData(transformedTableData);
        var transformedChartData = toChartData(fundDataObject, t('lineChartLabel'));
        setChartData(transformedChartData);

        setTimeout(() => {
          window.applicationReInit(['LifecycleAllocation', 'FormSelect']);
        }, 100);        
      };
    
      fetchData().catch((error) => console.error(error));

    }, [fundDataUrl, language, t]);


    if (!chartData || !fundData) {
      return <div>Loading...</div>;
    }

    return (
      <div className="l-container m-lifecycle-allocation u-margin-top-xl u-margin-bottom-xl"
          data-labels={JSON.stringify({
            chartlabel: chartProductName,
            riskyAssetsLabel: riskyAssetsLabel,
            defensiveAssetsLabel: defensiveAssetsLabel,
            totalLabel: t('overallLabel'),
            yearLabel: {year: t("yearLabel"), years: t("yearsLabel")},
            initialSliderLabel: t('initialSliderLabel'),
            stackedChartTooltipLabel: {year: t("stackedChartTooltipYearLabel"), years: t("stackedChartTooltipYearsLabel")}
          })}
          data-chart={JSON.stringify(chartData)}>

          <GlidepathHeader GlidepathHeaderLabels={GlidepathHeaderLabels} />
          <GlidepathStackedChartWithSlider GlidepathStackedChartWithSliderLabels={GlidepathStackedChartWithSliderLabels} maxYear={chartDataMaxYear} />
          <GlidepathPieChart />
          {/* <!-- START: Allocator Content --> */}
          <FundAllocationTable fundData={fundData} isTableExpandedByDefault={isTableExpandedByDefault} />
          {/* <!-- END: Allocator Content --> */}
          <GlidepathDisclaimer GlidepathDisclaimerLabels={GlidepathDisclaimerLabels} fundData={fundData} />
      </div>
  )
}

export default GlidePathAllocation;